export const parseUserDetails = (data) => {
    const userDetails = { ...data };

    const ageDiffMs = Date.now() - new Date(userDetails.birthDate).getTime();
    const ageDate = new Date(ageDiffMs);

    userDetails.age = Math.abs(ageDate.getUTCFullYear() - 1970);

    return userDetails;
};
